import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IAddMaHolderLookupListFormValues } from '../../../../../interfaces/lookup/maHolder';
import { IAddMaHolder } from '../../../../../interfaces/lookup/maHolder/data';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { FetchResult } from '../../../../../shared/components/fetchResult/FetchResult';
import { ROW_GUTTER } from '../../../../../shared/Constants';
import { isError } from '../../../../../shared/helpers';
import { AppDispatch, RootState } from '../../../../../store';
import { addMaHolder } from '../../../../../store/lookupSlice/LookupActions';

export const MaHolderLookupListAdd = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const lookupSlice = useSelector((state: RootState) => state.lookupSlice);

    const onFinish = (values: IAddMaHolderLookupListFormValues) => {
        const body: IAddMaHolder = {
            ...(values as any),
        };

        dispatch(addMaHolder(body));
    };

    useEffect(() => {
        if (lookupSlice.detailsPage.maHolder.createStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/ma-holder', { replace: true });
        }
    }, [lookupSlice.detailsPage.maHolder.createStatus]);

    return (
        <Form
            form={form}
            name="maholder-lookup-add"
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={(changedValue: any, values) => {
                form.setFieldsValue(values);
            }}
        >
            <ContentHeader
                title="Manage MA holder lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'MA holder',
                        path: '/admin/lookup-lists/ma-holder',
                    },
                    {
                        breadcrumbName: 'Create',
                        path: `/admin/lookup-lists/ma-holder/add`,
                    },
                ]}
            >
                {!isError(lookupSlice.detailsPage.maHolder.fetchStatus) && (
                    <Form.Item>
                        <Space>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => navigate(-1)}
                                disabled={
                                    lookupSlice.detailsPage.maHolder.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.maHolder.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Close
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={
                                    lookupSlice.detailsPage.maHolder.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.maHolder.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Save and close
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </ContentHeader>

            <div className="page-content">
                <Spin spinning={lookupSlice.detailsPage.maHolder.fetchStatus === StatePieceStatus.IsFetching}>
                    {isError(lookupSlice.detailsPage.maHolder.fetchStatus) ? (
                        <FetchResult status={lookupSlice.detailsPage.maHolder.fetchStatus} about={'MA Holder'} />
                    ) : (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Space>
                                        <label className="group-label">MA Holder option Information</label>
                                    </Space>
                                </Col>
                            </Row>
                            <Row gutter={ROW_GUTTER}>
                                <Col span={8}>
                                    <label className="property required">Code</label>
                                    <Form.Item name="code" rules={[{ required: true, message: "'Code' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <label className="property required">Description</label>
                                    <Form.Item name="description" rules={[{ required: true, message: "'Description' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>&nbsp;</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        </Form>
    );
};
